import { useSelector } from 'react-redux';

import ResourceImage from '../../ResourceImage/ResourceImage';
import T from '../../i18n/i18n';
import { TableItemCell, TableItemOwner, TableItemName, TableItemLabel, TableAccessLabel, TableImage, TableItemContent } from './TableItem.styles';
import { TableItemNewInput, TableItemNewOK, TableItemNewCancel } from '../TablesList/TablesList.styles';

export default ({onOpen, onAccept, onDeny, table}) => {

    const playerId = useSelector(state => state.authState.id);

    const handleOpen = () => {
        if (typeof onOpen === 'function') {
            onOpen(table);
        }
    }

    const handleAccept = () => {
        if (typeof onAccept === 'function') {
            onAccept(table);
        }
    }

    const handleDeny = () => {
        if (typeof onDeny === 'function') {
            onDeny(table);
        }
    }

    return <TableItemCell onClick={handleOpen}>
        <TableImage>
            {table.thumbnail ? <ResourceImage resourceId={table.thumbnail} /> : null}
        </TableImage>
        <TableItemContent>
            <TableItemName className='text'>{table.name}</TableItemName>
            {table.joined === 0 && <>
                <TableItemLabel><span className="mdi mdi-calendar mdi-18px"></span> {table.nextEncounter}</TableItemLabel>
                <TableItemLabel><span className="mdi mdi-account-multiple mdi-18px"></span> {table.participants.length + 1} <T value="tables.players" /></TableItemLabel>
                {table.owner === playerId ? <TableItemOwner /> : null}
            </>}
            {table.joined === 1 && <TableAccessLabel><T value="tables.waitingaccess" /></TableAccessLabel>}
            {table.joined === 2 && <>
                <TableItemNewInput>
                    <TableAccessLabel><T value="tables.joinaccess" /></TableAccessLabel>
                    <TableItemNewOK onClick={handleAccept}><span className="mdi mdi-check mdi-18px"></span></TableItemNewOK>
                    <TableItemNewCancel onClick={handleDeny}><span className="mdi mdi-close mdi-18px"></span></TableItemNewCancel>
                </TableItemNewInput>
            </>}
        </TableItemContent>
    </TableItemCell>
};